/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* A place for VDK Web CTV UI components and utilities (@accedo/vdkweb-tv-ui) 7.1.2
* 
*******************************************************************************/
import { backspaceSingleButton, clearDoublespaceButton, uppercaseSingleButton, layoutSymbolsButton, layoutLettersButton, spaceFourspaceButton } from '../sharedSpecialKeys';
var FEATURE_KEY = {
  UPPERCASE: uppercaseSingleButton,
  BACKSPACE: backspaceSingleButton,
  LAYOUT2: layoutSymbolsButton,
  LAYOUT1: layoutLettersButton,
  SPACE: spaceFourspaceButton,
  CLEAR: clearDoublespaceButton
};
var textArray = ['ح', 'ج', 'ث', 'ت', 'ب', 'ا', 'س', 'ز', 'ر', 'ذ', 'د', 'خ', 'ع', 'ظ', 'ط', 'ض', 'ص', 'ش', 'م', 'ل', 'ك', 'ق', 'كف', 'غ', 'أ', 'ء', 'ي', 'و', 'ه', 'ن', 'ى', 'ئ', 'ؤ', 'ة', 'آ', 'إ'].concat(['@', '.']).concat(Object.entries(FEATURE_KEY).map(function (obj) {
  return obj[1].text;
}));
export { textArray, FEATURE_KEY };